<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import ArticleCard from './ArticleCard.svelte';
	import ArticleList from './ArticleList.svelte';
	import ArrowRight from '$lib/assets/images/icons/arrow-right-dark.svg?component';
	import ProductBanner from './Banners/ProductBanner.svelte';
	import { page } from '$app/stores';
	import CategoryCta from './CategoryCta.svelte';

	export let articles: IndexData;
	export let category: Category;

	$: ({ latest, highlights, mostViewed } = articles);

	highlights = highlights?.slice(0, 4);
	mostViewed = mostViewed?.slice(0, 4);
</script>

<div class="container mx-auto bg-white">
	<div class="flex flex-col gap-y-8 py-10 text-dark md:px-8">
		<!-- <ArticleList
			articles={highlights}
			contentClass="grid-cols-none md:grid-cols-4 divide-y-2 md:divide-y-0 md:divide-x"
			let:article
		>
			<ArticleCard
				slot="first"
				class="py-2 pb-2 md:pr-6"
				let:article
				{article}
				titleClass="line-clamp-3 text-lg"
				labelClass="md:basis-10 text-sm font-semibold uppercase text-primary"
				compact
				withoutCover
			/>
			<ArticleCard
				class="py-2 md:px-6"
				{article}
				titleClass="line-clamp-3 text-lg"
				labelClass="md:basis-10 text-sm font-semibold uppercase text-primary"
				compact
				withoutCover
			/>
			<ArticleCard
				slot="last"
				class="py-2 md:pl-6"
				let:article
				{article}
				titleClass="line-clamp-3 text-lg"
				labelClass="md:basis-10 text-sm font-semibold uppercase text-primary"
				compact
				withoutCover
			/>
		</ArticleList> -->
		<div>
			<div class="py-4">
				<h3 class="text-caption">{$__('Categorias')}</h3>
			</div>
			<div
				class="grid w-full grid-cols-2 items-center gap-3 uppercase text-white md:grid-cols-3 md:flex-row lg:grid-cols-6"
			>
				<CategoryCta
					href="{$page.data?.location?.origin}/artigos/credito-habitacao"
					label={$__('Crédito Habitação')}
				/>
				<CategoryCta
					class="bg-primary-light text-dark"
					href="{$page.data?.location?.origin}/artigos/credito-pessoal"
					label={$__('Crédito pessoal')}
				/>
				<CategoryCta
					class="bg-secondary-bright"
					href="{$page.data?.location?.origin}/artigos/seguros"
					label={$__('Seguros')}
				/>
				<CategoryCta
					class="bg-secondary"
					href="{$page.data?.location?.origin}/artigos/poupanca"
					label={$__('Poupança')}
				/>
				<CategoryCta
					class="bg-slate-bright text-dark"
					href="{$page.data?.location?.origin}/artigos/imobiliario"
					label={$__('Imobiliário')}
				/>
				<CategoryCta
					class="bg-slate"
					href="{$page.data?.location?.origin}/artigos/institucional"
					label={$__('Institucional')}
				/>
			</div>
		</div>

		<ArticleList title={$__('Destaques')} articles={highlights} let:article>
			<header slot="header" let:title class="flex py-4">
				<h1 class="text-caption">{title}</h1>
				<a
					href="{$page.data?.location?.origin}/artigos/sobre/categoria/{category.slug !== 'home'
						? category.slug
						: 'artigos'}/destaques"
					class="ml-auto flex items-center gap-x-2 text-primary"
				>
					<p class="hidden text-sm uppercase md:block">{$__('Ver tudo')}</p>
					<ArrowRight class="fill-primary" />
				</a>
			</header>
			<ArticleCard {article}>
				<footer slot="footer" class="mt-auto">
					<p class="text-xs">
						<span class="read_duration">{article.read_duration} min</span>
					</p>
				</footer>
			</ArticleCard>
		</ArticleList>

		<ArticleList
			title={$__('Mais recentes')}
			articles={latest}
			seeMoreUrl="{$page.data?.location?.origin}/artigos/sobre/categoria/{category.slug !== 'home'
				? category.slug
				: 'artigos'}/recentes"
		/>

		<ProductBanner intent={category?.slug} />

		<ArticleList
			title={$__('Mais lidos')}
			articles={mostViewed}
			contentClass="grid-cols-2 grid-rows-2 lg:grid-cols-5 lg:grid-rows-3 gap-4"
			seeMoreUrl="{$page.data?.location?.origin}/artigos/sobre/categoria/{category.slug !== 'home'
				? category.slug
				: 'artigos'}/mais-lidas"
			let:article
		>
			<ArticleCard
				slot="first"
				class="h-full lg:col-span-2 lg:row-span-3"
				{article}
				customCoverClass=""
				footerClass="hidden"
				compact
			/>
			<ArticleCard
				class="h-full lg:col-span-3 lg:row-span-1 lg:bg-light lg:p-4"
				{article}
				footerClass="hidden"
				customCoverClass="lg:basis-44 lg:shrink-0"
				headerClass="flex flex-col space-y-5 lg:flex-row lg:gap-x-4"
				compact
			/>
		</ArticleList>
	</div>
</div>
